import { useWizardStateContext } from '../_contexts/WizardStateProvider';
import StepImage from './StepImage';
import getWizardData from './utils/getWizardData';

const FinishStepImage = () => {
  const { currentRoute } = useWizardStateContext();

  const accessory = currentRoute.accessory;
  const style = currentRoute.style;
  const finish = currentRoute.finish;

  const wizard = getWizardData({
    accessory: accessory.value,
    style: style.value,
    finish: finish.value,
  });
  const finishStep = wizard?.finishStep;
  const image = finishStep?.image;

  return <StepImage image={image} />;
};

export default FinishStepImage;
